import React from 'react';
import { useAchievementTakeover } from '../../../hooks/useAchievementTakeover';

/**
 * Component that listens for achievement earned events and opens the badge earned takeover
 * This component must be rendered inside the TakeoverProvider to access the takeover context
 */
export const AchievementTakeoverListener: React.FC = () => {
  useAchievementTakeover();
  return null;
};
